import { render, staticRenderFns } from "./DeleteUserDialog.vue?vue&type=template&id=3787b2fc&scoped=true&"
import script from "./DeleteUserDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteUserDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3787b2fc",
  null
  
)

export default component.exports